// extracted by mini-css-extract-plugin
export default {"themeProvider":"App_themeProvider__aJ09Q"};